import { Box } from "@mui/material"
import React from "react"
import { useMediaQuery } from "react-responsive"
import { MENU_TYPE, SUB_MENU_TYPE } from "src/modules/const"
import { CommonLayout } from "../CommonLayout"
import { TopMenuItem } from "../TopMenuItem"
import { ChangePasswordPageItem } from "./ChangePasswordPageItem"
import { ProfilePageItem } from "./ProfilePageItem"

const subMenu = [
  {
    title: "register_information_change",
    icon: "register_information_change",
    index: SUB_MENU_TYPE.REGISTER_INFO_CHANGE,
    page: <ProfilePageItem />,
    search: null,
    link: "/profile/update",
  },
  {
    title: "password_change",
    icon: "password_change",
    index: SUB_MENU_TYPE.REGISTER_PASS_CHANGE,
    page: <ChangePasswordPageItem />,
    search: null,
    link: "/profile/password",
  },
]

interface Props {
  subMenuIndex: number
}

export const ProfilesPage = ({ subMenuIndex }: Props) => {
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  return (
    <>
      {isTablet ? (
        <></>
      ) : (
        <Box position="absolute" sx={{ width: "100%", height: "60px" }}>
          <Box display="flex">
            <TopMenuItem
              mainMenuIndex={MENU_TYPE.REGISTER_INFORMATION}
              subMenuIndex={subMenuIndex}
            />
          </Box>
        </Box>
      )}

      <CommonLayout subMenu={subMenu} subMenuIndex={subMenuIndex} />
    </>
  )
}
